<form [formGroup]="formGroup()">
  <div class="card">
    <div class="card-header">
      {{
        "registrationWizard.investmentQualificationTest.knowledgeTestForm.knowledgeTest"
          | translate
      }}
    </div>
    <div class="card-body">
      <div class="notification my-2">
        <span class="icon bi-info-circle me-2"></span
        ><span
          class="text my-a"
          [innerHTML]="
            'registrationWizard.investmentQualificationTest.knowledgeTestForm.clarifyInfo'
              | translate
          "
        ></span>
      </div>
      <hr />
      <div class="sub-header">
        {{ "general.income" | translate }}
      </div>
      <div class="notification my-2">
        <span class="icon bi-info-circle me-2"></span
        ><span
          class="text my-a"
          [innerHTML]="
            'registrationWizard.investmentQualificationTest.knowledgeTestForm.clarify'
              | translate
          "
        ></span>
      </div>

      <app-validated-dropdown
        label="general.currency"
        [inputFormControl]="selectedCurrency"
        inputFormControlName="selectedCurrency"
        [loading]="!store.allLoaded()"
        [optionsStamp]="store.currenciesEntities().length"
      >
        @for(currency of store.currenciesEntities(); track currency.id){
        <option [value]="currency.code">
          {{ currency.localized | getLocalized }}
        </option>

        }
      </app-validated-dropdown>

      <app-income-table
        [formControls]="formGroup().controls.incomes"
        [currencyCode]="selectedCurrency.value"
        [canAdd]="true"
        (createNewFileGroup)="createNewFileGroup(formGroup().controls.incomes)"
      ></app-income-table>

      <div class="row flex-between-center">
        <div class="col-auto my-2 section-container">
          <label class="form-label section-title">{{
            "registrationWizard.investmentQualificationTest.knowledgeTestForm.totalIncomeInAMonth"
              | translate
          }}</label>
          <div class="section section-background">
            {{
              incomeSum
                | appCurrency : getCurrencyConfig(selectedCurrency.value)
            }}
          </div>
          <span class="section-info">{{
            "registrationWizard.investmentQualificationTest.knowledgeTestForm.totalIncomeInAMonthInfo"
              | translate
          }}</span>
        </div>
      </div>

      <div class="row flex-between-center">
        <div class="col-auto my-2 section-container">
          <app-validated-currency-input
            label="registrationWizard.investmentQualificationTest.knowledgeTestForm.availableFounds"
            [currencyCode]="selectedCurrency.value"
            [inputFormControl]="formGroup().controls.availableFounds"
            inputFormControlName="availableFounds"
          ></app-validated-currency-input>
          <span class="section-info">{{
            "registrationWizard.investmentQualificationTest.knowledgeTestForm.availableFoundsInfo"
              | translate
          }}</span>
        </div>
      </div>

      <div class="row flex-between-center">
        <div class="col-auto my-2 section-container">
          <app-validated-currency-input
            label="registrationWizard.investmentQualificationTest.knowledgeTestForm.financialCommitmentsValue"
            [currencyCode]="selectedCurrency.value"
            [inputFormControl]="formGroup().controls.financialCommitmentsValue"
            inputFormControlName="financialCommitmentsValue"
          ></app-validated-currency-input>
          <span class="section-info">{{
            "registrationWizard.investmentQualificationTest.knowledgeTestForm.financialCommitmentsValueInfo"
              | translate
          }}</span>
        </div>
      </div>

      <div class="row flex-between-center">
        <div class="col-auto my-2 section-container">
          <div class="l-display-container">
            <label class="form-label section-info">{{
              "registrationWizard.investmentQualificationTest.knowledgeTestForm.currentNetWealth"
                | translate
            }}</label>
            <div class="l-display-text">
              <span>{{
                currentNetWealth()
                  | appCurrency : getCurrencyConfig(selectedCurrency.value)
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row flex-between-center">
        <div class="col-auto my-2 section-container">
          <div class="l-display-container">
            <label class="form-label section-info">{{
              "registrationWizard.investmentQualificationTest.knowledgeTestForm.netWealthAfterLoss"
                | translate
            }}</label>
            <div class="xl-display-text">
              <span>{{
                currentNetWealth() * 0.9
                  | appCurrency : getCurrencyConfig(selectedCurrency.value)
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row flex-between-center">
        <div class="col-12 my-2">
          <app-validated-checkbox
            label="registrationWizard.investmentQualificationTest.knowledgeTestForm.validStatements"
            inputFormControlName="validStatements"
            [inputFormControl]="formGroup().controls.validStatements"
            [validationTrainslations]="{ requiredTrue: 'validation.required' }"
            [dense]="true"
          />
        </div>
        <div class="col-12 my-2">
          <app-validated-checkbox
            label="registrationWizard.investmentQualificationTest.knowledgeTestForm.simulationUnderstood"
            inputFormControlName="understoodTheSimulation"
            [inputFormControl]="formGroup().controls.understoodTheSimulation"
            [validationTrainslations]="{ requiredTrue: 'validation.required' }"
            [dense]="true"
          />
        </div>
        <div class="col-12 my-2">
          <app-validated-checkbox
            label="registrationWizard.investmentQualificationTest.knowledgeTestForm.simulationReceived"
            inputFormControlName="resultReceived"
            [inputFormControl]="formGroup().controls.resultReceived"
            [validationTrainslations]="{ requiredTrue: 'validation.required' }"
            [dense]="true"
          />
        </div>
      </div>
    </div>
  </div>
</form>
